/* Monsuri — content-block promotion tracking (GA4 view_promotion / select_promotion).
 *
 * Answers "are our on-site blocks driving product views & purchases?" by emitting the
 * GA4-standard internal-promotion events for every block carrying a `data-promo-id`.
 * The items[] array (with promotion_id/name/creative_slot) is what populates GA4's
 * native item-promotion reports + the dashboard's Ga4PromotionDaily table.
 *
 * Delivery mirrors assets/mds-tracking.js: gtag() direct (the storefront loads GA4 via
 * gtag, not GTM), with a dataLayer.push fallback. Additive only — Elevar still owns
 * the ecommerce events; we never emit add_to_cart/purchase here (the one exception is a
 * corp bundle CTA that genuinely adds, gated on data-promo-action="add").
 *
 * One IntersectionObserver (fire-once per id) + one delegated click listener — no
 * per-element listeners. Never throws. See Documentation/GA4_MEASUREMENT_PLAN.md.
 */
(function () {
  'use strict';

  var GA4_MEASUREMENT_ID = 'G-04VG181C0C';

  function track(event, params) {
    try {
      if (typeof window.gtag === 'function') {
        var p = { send_to: GA4_MEASUREMENT_ID };
        if (params) for (var k in params) if (Object.prototype.hasOwnProperty.call(params, k)) p[k] = params[k];
        window.gtag('event', event, p);
        return;
      }
      window.dataLayer = window.dataLayer || [];
      var payload = { event: event };
      if (params) for (var j in params) if (Object.prototype.hasOwnProperty.call(params, j)) payload[j] = params[j];
      window.dataLayer.push(payload);
    } catch (e) { /* never break the page for analytics */ }
  }

  function locationId() {
    return (window.Shopify && window.Shopify.template) || document.documentElement.getAttribute('data-template') || '';
  }

  // Read the promotion fields off the nearest [data-promo-id] ancestor (or the el itself).
  function promoParams(el) {
    var id = el.getAttribute('data-promo-id') || '';
    var name = el.getAttribute('data-promo-name') || '';
    var slot = el.getAttribute('data-promo-slot') || '';
    var section = el.getAttribute('data-promo-section') || '';
    var itemHandle = el.getAttribute('data-promo-item-handle') || id;
    return {
      promotion_id: id,
      promotion_name: name,
      creative_slot: slot,
      section_type: section,
      location_id: locationId(),
      items: [{ item_id: itemHandle, promotion_id: id, promotion_name: name, creative_slot: slot }]
    };
  }

  // ── Impressions: one IntersectionObserver, fire once per promo id ──
  var fired = {};
  var io = null;
  function ensureObserver() {
    if (io || !('IntersectionObserver' in window)) return;
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (!entry.isIntersecting) continue;
        var el = entry.target;
        var id = el.getAttribute('data-promo-id');
        if (id && !fired[id]) {
          fired[id] = true;
          io.unobserve(el);
          track('view_promotion', promoParams(el));
        }
      }
    }, { threshold: 0.5 });
  }

  function observeAll() {
    if (!('IntersectionObserver' in window)) return; // clicks still work without impressions
    ensureObserver();
    var els = document.querySelectorAll('[data-promo-id]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-promo-observed')) continue;
      el.setAttribute('data-promo-observed', '1');
      io.observe(el);
    }
  }

  // ── Clicks: one delegated listener (capture phase, before navigation) ──
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var el = t.closest('[data-promo-id]');
    if (!el) return;
    var params = promoParams(el);
    // Destination = the ACTUAL clicked anchor's href when the click landed on (or inside)
    // a link within this promo container — so a slide with two CTAs, or a product card with
    // variant swatches, reports the real target instead of the container's first descendant
    // link. Falls back to el's own href, then the first descendant link. (Codex review.)
    var clickedAnchor = t.closest && t.closest('a[href]');
    var clickedHref = clickedAnchor && el.contains(clickedAnchor) ? clickedAnchor.getAttribute('href') : '';
    params.promotion_destination = clickedHref || el.getAttribute('href') || (el.querySelector && el.querySelector('a[href]') ? el.querySelector('a[href]').getAttribute('href') : '') || '';
    track('select_promotion', params);
    // A corp bundle CTA that genuinely adds a product to cart → also a corp add KEY event.
    // Gated so we never duplicate Elevar's add_to_cart on ordinary promo links.
    if (el.getAttribute('data-promo-action') === 'add' && params.promotion_destination.indexOf('/products/') !== -1) {
      track('corp_bundle_add_to_cart', {
        promotion_id: params.promotion_id,
        section_type: params.section_type,
        location_id: params.location_id,
        product_handle: el.getAttribute('data-promo-item-handle') || ''
      });
    }
  }, true);

  // Observe on load + when sections (re)mount (theme editor + lazy sections).
  if (document.readyState !== 'loading') observeAll();
  else document.addEventListener('DOMContentLoaded', observeAll);
  document.addEventListener('shopify:section:load', observeAll);
})();
